/**
 * Утилиты для определения текущего домена и условного отображения контента
 */

/**
 * Домены, на которых разрешено показывать основной телефон 8 (920) 324-03-93.
 * На всех остальных доменах основной телефон скрывается.
 */
const MAIN_PHONE_ALLOWED_DOMAINS = ['ok-telecom.ru'];

/**
 * Проверяет, нужно ли показывать основной телефон на текущем домене.
 *
 * Основной телефон отображается только на доменах из списка
 * MAIN_PHONE_ALLOWED_DOMAINS (например, ok-telecom.ru). На прочих доменах
 * (skylunet.ru и любых других) он скрывается.
 *
 * @returns true, если текущий домен входит в список разрешённых
 *
 * @example
 * if (shouldShowMainPhone()) {
 *   // показать основной телефон
 * }
 */
export function shouldShowMainPhone(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = window.location.hostname.toLowerCase();
  return MAIN_PHONE_ALLOWED_DOMAINS.some((domain) => hostname.endsWith(domain));
}

/**
 * Проверяет, нужно ли скрывать основной телефон на текущем домене.
 *
 * Обратная к {@link shouldShowMainPhone}. Телефон скрывается везде, кроме
 * разрешённых доменов (ok-telecom.ru).
 *
 * @returns true, если основной телефон нужно скрыть
 *
 * @example
 * if (isSkylunetDomain()) {
 *   // скрыть основной телефон
 * }
 */
export function isSkylunetDomain(): boolean {
  return !shouldShowMainPhone();
}
